<template>
  <div class="Application-buttons" v-if="application">
    <ApplicationListItemButton
      :id="application.id"
      :listmode="false"
      :selected="application.meeting"
      :hasMeeting="!!application.meeting"
    />
    <div class="Remove-application">
      <button
        class="Button Button--decline Button--large"
        @click="showForm = true"
      >
        Ta bort ansökan
      </button>
      <Modal
        :visible="showForm"
        title="Ta bort ansökan"
        @submit="submit"
        @cancel="cancel"
      >
        <template slot="content">
          <p class="Modal__desc">
            Är du säker på att du vill ta bort den här ansökan?
          </p>
        </template>
        <template slot="buttons">
          <div class="Modal__button">
            <button
              type="button"
              class="Button Button Button--secondary"
              @click="cancel"
            >
              Avbryt
            </button>
          </div>
          <div class="Modal__button">
            <button type="submit" class="Button Button Button--primary">
              Ja
            </button>
          </div>
        </template>
      </Modal>
    </div>    
      <a
        v-if="parsedCreditsafeId"        
        :href="`https://app.creditsafe.se/CSSEWebsite/WebPages/Company/CreditReport/Summary.aspx?CompanyNumber=${parsedCreditsafeId}`"
        target="_blank"
      >
      <button class="Button Button--primary Button--large">
        Creditsafe
      </button>
          
      </a>
    
  </div>
</template>

<script>
import _ from "lodash";
import { mapState, mapActions } from "vuex";
import Modal from "@/components/Modal";
import ApplicationListItemButton from "../../application-list/components/ApplicationListItemButton";

export default {
  name: "ApplicationButtons",
  components: { ApplicationListItemButton, Modal },
  data() {
    return {
      showForm: false
    };
  },
  computed: {
    ...mapState("applicationStore", ["application"]),
    parsedCreditsafeId(){
      return this.application?_.replace(this.application.orgNo, "-", ""): null;
    }
  },
  methods: {
    ...mapActions("applicationListStore", ["pauseApplication"]),
    ...mapActions("applicationStore", ["getApplication", "deleteApplication"]),

    cancel() {
      this.showForm = false;
      setTimeout(() => {
        this.reset();
      }, 200);
    },
    submit() {
      this.deleteApplication(this.application.id);
    },
    reset() {
      this.$v.$reset();
    }
  }
};
</script>

<style lang="scss">
.Application-buttons {
  .Button {
    width: 100%;
    &:first-child {
      margin-bottom: $spacing;
    }
  }
}
</style>
